export const LOCALE_TO_ID: Record<string, number> = {
  ko: 1,
  'ko-KR': 1,
  en: 2,
  'en-US': 2,
  ja: 3,
  'ja-JP': 3,
}

export const ID_TO_LOCALE: Record<number, string> = {
  1: 'ko-KR',
  2: 'en-US',
  3: 'ja-JP',
}
